
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 获取当前用户积分
 * @returns 
 */
 export const getCurrentPoint = (): any  => {
    return axios.get(`${baseURL}/UserPoints/GetCurrentPoint`)
}

/**
 * 获取当前公益积分
 * @returns 
 */
 export const getWhenMoneyUse = (): any  => {
    return axios.get(`${baseURL}/UserPoints/WhenMoneyUse`)
}
   

/**
 * 获取当前用户使用情况
 * @returns 
 */
 export const getMyPointLst = (pageNum:number,pageSize:number): any  => {
    return axios.get(`${baseURL}/UserPoints?pageNum=${pageNum}&pageSize=${pageSize}`)
}

